import { FunctionComponent } from "react"
import Loader from "src/components/common/Loader"
import "./PageLoaderWithIcon.css"

interface Props {
    icon: string
    loaderText: string
    id?: string
}

const PageLoaderWithIcon: FunctionComponent<Props> = (props) => {

    const { icon, loaderText, id } = props

    return (
        <div 
        id={id ? id : ""}
        className="PageLoaderWithIcon"
        >
            <span className="material-icons">{icon}</span>
            <Loader title={loaderText} />
        </div>
    )
}

export default PageLoaderWithIcon